import { z } from "zod";

export const organizationalUnitTypeSchema = z.enum([
  "department",
  "center",
  "institute",
  "program",
  "division",
  "college_or_school",
  "core_or_facility",
  "other",
]);

export type OrganizationalUnitType = z.infer<
  typeof organizationalUnitTypeSchema
>;
